import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import apiDefinitions from '../../../../core/api/apiDefinitions';
import { showError, showSuccess } from '../../../../core/alert/sweetAlertConfig';

interface CreateWindowModuleProps {
  show: boolean;
  onHide: () => void;
  roomId: number;
  roomName: string;
  onSuccess: () => void;
}

const CreateWindowModule: React.FC<CreateWindowModuleProps> = ({ show, onHide, roomId, roomName, onSuccess }) => {
  const [windowName, setWindowName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!windowName.trim()) {
      showError('Window name is required.');
      return;
    }
    setIsLoading(true);
    try {
      const payload = { windowName, roomId };
      const response = await apiDefinitions.addWindow(payload);
      if (response.status === 200 && (response.data.status === 'S1000' || response.data.status === 'SUCCESS')) {
        showSuccess("Window created successfully");
        onSuccess();
        onHide();
      } else {
        showError(response.data?.statusDescription || 'Failed to create window.');
      }
    } catch (err: any) {
      showError(err.response?.data?.statusDescription || 'Failed to create window. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create Window for {roomName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Window Name</label>
          <input
            type="text"
            className="form-control"
            value={windowName}
            onChange={(e) => setWindowName(e.target.value)}
            placeholder="Enter window name"
            disabled={isLoading}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Room</label>
          <input type="text" className="form-control" value={roomName} disabled />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateWindowModule;